import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import ElectricMotor from 'features/processFlowDiagrams/svg/engines/electric-motor.svg?react'
import ElectricMotorAc from 'features/processFlowDiagrams/svg/engines/electric-motor-ac.svg?react'
import ElectricMotorDc from 'features/processFlowDiagrams/svg/engines/electric-motor-dc.svg?react'
import Gear from 'features/processFlowDiagrams/svg/engines/gear.svg?react'
import Generator from 'features/processFlowDiagrams/svg/engines/generator.svg?react'
import GeneratorAc from 'features/processFlowDiagrams/svg/engines/generator-ac.svg?react'
import GeneratorDc from 'features/processFlowDiagrams/svg/engines/generator-dc.svg?react'
import Turbine from 'features/processFlowDiagrams/svg/engines/turbine.svg?react'
import React from 'react'

export const PID_ENGINES_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'electric-motor',
    name: 'Electric Motor',
    category: 'engines',
    svgContent: <ElectricMotor />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'electric-motor-ac',
    name: 'Electric Motor (AC)',
    category: 'engines',
    svgContent: <ElectricMotorAc />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'electric-motor-dc',
    name: 'Electric Motor (DC)',
    category: 'engines',
    svgContent: <ElectricMotorDc />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'gear',
    name: 'Gear',
    category: 'engines',
    svgContent: <Gear />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'generator',
    name: 'Generator',
    category: 'engines',
    svgContent: <Generator />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'generator-ac',
    name: 'Generator (AC)',
    category: 'engines',
    svgContent: <GeneratorAc />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'generator-dc',
    name: 'Generator (DC)',
    category: 'engines',
    svgContent: <GeneratorDc />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'turbine',
    name: 'Turbine',
    category: 'engines',
    svgContent: <Turbine />,
    viewBox: '0 0 70 100',
  },
]
